<template>
  <template v-if="!loading">
    <div class="p-5 rounded bg-body d-flex justify-content-between align-items-center mb-5">
      <h4 class="fw-bold text-gray-900 mb-0 ms-lg-4">
        {{ this.$route.meta.title || 'Страница' }}
        <span class="mt-2 d-block fw-normal fs-8 text-muted">Количество коннекторов: {{ placemarks ? placemarks.length : 0 }}</span>
      </h4>
      <div class="card-toolbar">
        <div class="custom-select dynamic w-175px w-lg-325px">
          <label for="selectedListInList" class="required">Локация</label>
          <v-select
            v-if="marketplaces"
            :loading="!marketplaces"
            v-model="selectedListInList"
            input-id="selectedListInList"
            :options="marketplaces"
            :disabled="!marketplaces.length"
            :reduce="item => item.id"
            :required="true"
            placeholder="Выберите..."
            class="bg-gray-100 form rounded"
            label="name"
          />
        </div>
      </div>
    </div>
    <div class="position-relative" style="margin-bottom: -30px">
      <div v-if="selectedPlace" class="bg-body p-5 rounded border position-absolute top-0 w-325px overflow-hidden m-3 start-0 z-index-1" style="height: calc(100% - 20px)">
        <loader class="h-100" v-if="detailLoading || !detailData"/>
        <template v-else>
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0">Детали группы станций:</h5>
            <div @click="clearSelectedPlaces" class="btn btn-icon btn-sm btn-active-light-primary">
              <i class="ki-duotone ki-cross fs-2x">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
          </div>
          <div class="mb-5 card shadow-sm p-5 rounded-0 border-top border-bottom" style="margin: 0 -16px">
            <div class="mb-1 d-flex align-items-center fs-5 fw-bold">
              <span class="w-10px h-10px rounded me-2" :class="selectedPlace.isActive ? 'bg-success' : 'bg-warning'"></span>{{ selectedPlace.name }}</div>
            <div v-if="!showNotesEditor" class="mb-3 text-gray-800 fw-bold">{{ selectedPlace.address }}</div>
            <div v-if="selectedPlaceMainNote && !showNotesEditor" class="mb-3 badge badge-secondary fw-bold text-wrap text-start">{{ selectedPlaceMainNote }}</div>
            <div class="mb-3">
              <button
                v-if="!showNotesEditor"
                type="button"
                class="btn w-100 btn-sm py-1 btn-light-primary"
                :disabled="!locationIdForPrice"
                @click="openNotesEditor"
              >
                {{ selectedPlaceHasNotes ? 'Изменить комментарий' : 'Добавить комментарий' }}
              </button>
            </div>
            <div v-if="showNotesEditor" class="mb-3">
              <area-field
                v-model="notesForm.RU"
                id="location-notes-ru"
                name="location-notes-ru"
                placeholder="Комментарий (RU)"
                mb="2"
              />
              <area-field
                v-model="notesForm.EN"
                id="location-notes-en"
                name="location-notes-en"
                placeholder="Comment (EN)"
                mb="2"
              />
              <area-field
                v-model="notesForm.UZ"
                id="location-notes-uz"
                name="location-notes-uz"
                placeholder="Izoh (UZ)"
                mb="3"
              />
              <div class="d-grid gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-light w-100"
                  :disabled="notesLoading"
                  @click="closeNotesEditor"
                >
                  Закрыть
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary w-100"
                  :disabled="notesLoading || !notesChanged || !locationIdForPrice"
                  @click="saveNotes"
                >
                  {{ notesLoading ? 'Сохранение...' : 'Сохранить' }}
                </button>
              </div>
            </div>
            <div v-if="!showNotesEditor" class="mb-1 d-flex align-items-center justify-content-between">
              <span class="text-gray-600">Количество коннекторов:</span>
              <span class="text-gray-800 fw-bold">{{ selectedPlace.connectorsTotal }}</span>
            </div>
          </div>
          <div class="overflow-y-auto" style="height: calc(100% - 250px)">
            <div class="rounded border bg-light-secondary p-3 mb-3" v-for="(item, key) in detailData.connectors">
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Коннектор {{key+1}}:</span>
                <span class="text-gray-800 fw-bold">{{ item.label }}</span>
              </div>
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Мощность:</span>
                <span class="text-gray-800 fw-bold">{{ item.power }} кВт</span>
              </div>
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Стоимость:</span>
                <span class="text-gray-800 fw-bold">{{ item.price ? item.price.toLocaleString('ru-RU')+' сум' : '' }}</span>
              </div>
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Старая цена:</span>
                <span class="text-gray-800 fw-bold">{{ item.oldPrice != null ? Number(item.oldPrice).toLocaleString('ru-RU')+' сум' : '' }}</span>
              </div>
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Тип:</span>
                <span class="text-gray-800 fw-bold">{{ item.type }}</span>
              </div>
              <div class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Статус:</span>
                <span class="text-gray-800 fw-bold">{{ item.status }}</span>
              </div>
              <div v-if="item.status === 'charging'" class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Заряд:</span>
                <span class="text-gray-800 fw-bold">{{ item.stateOfCharge }} %</span>
              </div>
              <div v-if="item.status === 'reserved'" class="mb-1 d-flex align-items-center justify-content-between">
                <span class="text-gray-600">Забронировано до:</span>
                <span class="text-gray-800 fw-bold">{{ item.bookingExpiredAt ? getHumanDate(item.bookingExpiredAt) : 'Не доступно' }}</span>
              </div>
            </div>
            <div class="mt-3 pt-3 border-top">
              <button type="button" class="btn btn-sm btn-primary w-100" @click="openPriceModal">
                Изменить цену
              </button>
            </div>
          </div>
        </template>
      </div>
      <location-price-modal
        v-if="detailData"
        :location-id="locationIdForPrice"
        :connectors="detailData.connectors || []"
        @success="onPriceUpdateSuccess"
        @close="closePriceModal"
      />
      <div class="rounded border p-1 bg-body mb-5">
        <div id="mainMap" style="width: 100%; height: calc(100vh - 280px)"></div>
      </div>
    </div>
    <div v-if="false" class="row">
      <div class="card bg-body rounded p-5 mb-5">
        <div
          v-for="(place, index) in marketplaces"
          :key="index"
          @click="selectMarketplaceFromList(index)"
          class="d-flex p-2 align-items-center cursor-pointer"
          :class="index+1 !== itemLength ? 'border-bottom border-gray-200' : ''"
        >
          <div class="symbol symbol-40px me-4">
              <span class="symbol-label" :class="index === activeItem ? 'bg-light-primary' : ''">
                <i class="ki-outline ki-geolocation fs-1" :class="index === activeItem ? 'text-primary' : ''"></i>
              </span>
          </div>
          <div class="p-2">
            <div :class="index === activeItem ? 'text-primary' : ''" class="fw-bold">{{place.name}}</div>
            <div :class="index === activeItem ? 'text-primary' : 'text-gray-400'">{{place.coords}}</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <div v-else class="card mh-275px">
    <loader />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import AreaField from '@/components/Fields/AreaField'
import InputMaskField from '@/components/Fields/InputMaskField'
import LocationPriceModal from '@/components/Modals/LocationPriceModal.vue'
import axios from 'axios'
import {notify} from '@kyvg/vue3-notification'
import Loader from '@/components/Loader'
import moment from "moment";
let map = null

export default {
  name: 'Map',
  components: {AreaField, Loader, vSelect, InputMaskField, LocationPriceModal},
  data() {
    return {
      loading: false,
      detailLoading: false,
      detailData: null,
      selectedListInList: null,
      selectedPlace: null,
      activeItem: null,
      marketplaces: [],
      placemarks: [], // для хранения ссылок на объекты
      notesForm: { RU: '', EN: '', UZ: '' },
      notesLoading: false,
      showNotesEditor: false,
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemLength() {
      return this.marketplaces.length;
    },
    locationIdForPrice() {
      const raw = this.selectedPlace?.locationCode ?? null
      return raw != null ? String(raw) : null
    },
    notesChanged() {
      const current = this.normalizeNotes(this.selectedPlace?.notes)
      return current.RU !== this.notesForm.RU || current.EN !== this.notesForm.EN || current.UZ !== this.notesForm.UZ
    },
    selectedPlaceMainNote() {
      const n = this.normalizeNotes(this.selectedPlace?.notes)
      return n.RU || n.EN || n.UZ || ''
    },
    selectedPlaceHasNotes() {
      const n = this.normalizeNotes(this.selectedPlace?.notes)
      return Boolean(n.RU || n.EN || n.UZ)
    },
  },
  methods: {
    normalizeNotes(notes) {
      if (Array.isArray(notes)) {
        const byLocale = notes.reduce((acc, item) => {
          const locale = String(item?.locale ?? '').toUpperCase()
          if (locale) acc[locale] = item?.note != null ? String(item.note) : ''
          return acc
        }, {})
        return {
          RU: byLocale.RU || '',
          EN: byLocale.EN || '',
          UZ: byLocale.UZ || '',
        }
      }
      const fallback = notes != null ? String(notes) : ''
      return { RU: fallback, EN: '', UZ: '' }
    },
    setNotesForm(notes) {
      this.notesForm = this.normalizeNotes(notes)
    },
    initMap() {
      const infoIconUrl = require('@/assets/images/info.svg')
      const promoIconUrl = require('@/assets/images/promo.svg')
      ymaps.ready(() => {
        map = new ymaps.Map('mainMap', {
          center: [41.311158, 69.279737],
          zoom: 12,
          controls: ['fullscreenControl'],
        }, {
          // Keep only custom placemarks; hide Yandex POI interactivity/open block.
          yandexMapDisablePoiInteractivity: true,
          suppressMapOpenBlock: true,
        });

        this.marketplaces.forEach((place, index) => {
          const total = place.connectorsTotal;
          const available = place.connectorsAvailable;
          const percentAvailable = total > 0 ? Math.round((available / total) * 100) : 0;
          const hasNotes = Boolean((this.notesLabel(place.notes) || '').trim())
          const hasMinOldPrice = place.minOldPrice !== null && place.minOldPrice !== undefined

          const placemarkSize = 60;
          const circleSize = 52;

          const placemark = new ymaps.Placemark(place.coords, {}, {
            iconLayout: 'default#imageWithContent',
            iconImageSize: [placemarkSize, placemarkSize],
            iconImageOffset: [-placemarkSize / 2, -placemarkSize], // центр + носик вниз
            iconContentLayout: ymaps.templateLayoutFactory.createClass(`
              <div style="
                width: ${placemarkSize}px;
                height: ${placemarkSize}px;
                position: relative;
                display: flex;
                align-items: flex-start;
                justify-content: center;
              ">
              ${hasNotes ? `
              <div style="
                position: absolute;
                top: -4px;
                right: 2px;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 3;
                border: 1px solid rgba(0,0,0,0.08);
                box-sizing: border-box;
                padding: 3px;
                pointer-events: none;
              "><img src="${infoIconUrl}" alt="" style="width: 100%; height: 100%; object-fit: contain; display: block;" /></div>
              ` : ''}
              ${hasMinOldPrice ? `
              <div style="
                position: absolute;
                top: -4px;
                left: 0px;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 3;
                border: 1px solid rgba(0,0,0,0.08);
                box-sizing: border-box;
                padding: 3px;
                pointer-events: none;
              "><img src="${promoIconUrl}" alt="" style="width: 100%; height: 100%; object-fit: contain; display: block;" /></div>
              ` : ''}
              <!-- Треугольник (носик вниз) -->
              <div style="
                position: absolute;
                bottom: 2px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid #2BB637;
                z-index: 1;
                pointer-events: none;
              "></div>
              <!-- Круг с прогресс-рамкой -->
              <div style="
                position: relative;
                width: ${circleSize}px;
                height: ${circleSize}px;
                background: white;
                border-radius: 50%;
                padding: 4px;
                background-image: conic-gradient(
                  #2BB637 0% ${percentAvailable}%,
                  #FFA500 ${percentAvailable}% 100%
                );
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 0 5px rgba(0,0,0,0.3);
                z-index: 2;
                pointer-events: none;
              ">
                <div style="
                  background: white;
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 14px;
                  color: black;
                  pointer-events: auto;
                ">
                    ${available} / ${total}
                </div>
              </div>
            </div>
          `)
          });

          placemark.events.add('click', () => {
            this.selectMarketplaceFromMap(index);
          });

          map.geoObjects.add(placemark);
          this.placemarks.push(placemark);
        });
      });
    },
    selectMarketplaceFromMap(index) {
      this.selectedPlace = this.marketplaces[index];
      this.setNotesForm(this.marketplaces[index]?.notes)
      this.showNotesEditor = false
      const coords = this.marketplaces[index].coords;
      if (map && coords) {
        this.getItemData(index)
        map.setCenter(coords, 15, { duration: 300 });
      }
      this.activeItem = index
    },
    selectMarketplaceFromList(index) {
      this.selectedPlace = this.marketplaces[index];
      this.setNotesForm(this.marketplaces[index]?.notes)
      this.showNotesEditor = false
      const coords = this.marketplaces[index].coords;
      this.activeItem = index

      if (map && coords) {
        this.getItemData(index)
        map.setCenter(coords, 15, { duration: 300 });
      }
    },
    clearSelectedPlaces() {
      if (map) {
        map.setCenter([41.311158, 69.279737], 12, { duration: 300 });
        this.selectedPlace = null;
        this.selectedListInList = null;
        this.setNotesForm(null);
        this.showNotesEditor = false
      }
    },
    getData() {
      this.loading = true;
      axios.get('partner-branching-service/api/v1/partners/points', {
        params: {page: 0, size: 500,},
      })
        .then(res => {
          if (res.data?.content?.length >= 0) {
            this.marketplaces = res.data.content.map(item => ({
              id: item.id,
              name: item.label,
              address: item.address,
              notes: item.notes ?? '',
              coords: [item.latitude, item.longitude],
              isActive: item.isActive,
              locationCode: item.locationCode,
              connectorsTotal: item.brief?.connectorsTotal || 0,
              connectorsAvailable: item.brief?.connectorsAvailable || 0,
              minPrice: item.brief?.minPrice || 0,
              minOldPrice: item.brief?.minOldPrice ?? null,
              maxPower: item.brief?.maxPower || 0
            }));
            this.initMap();
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Что-то пошло не так!',
            });
          }
        })
        .catch(error => {
          console.error('Ошибка при выполнении запроса:', error);
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          });
        })
        .finally(() => { this.loading = false; });
    },
    getHumanDate(date) {
      if (!date) return '';
      return moment(date).format('DD.MM.YYYY HH:mm:ss');
    },
    getItemData(index) {
      this.detailLoading = true;
      axios.get('station-processing-service/api/v1/locations/'+this.marketplaces[index].locationCode)
        .then(res => {
          if (res.data) {
            this.detailData = res.data;
            if (res.data.notes !== undefined && this.selectedPlace) {
              this.updateSelectedPlaceNotes(res.data.notes ?? '')
            }
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Что-то пошло не так!',
            });
          }
        })
        .catch(error => {
          console.error('Ошибка при выполнении запроса:', error);
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          });
        })
        .finally(() => { this.detailLoading = false; });
    },
    updateSelectedPlaceNotes(notes) {
      if (this.selectedPlace) {
        this.selectedPlace.notes = notes
      }
      if (this.activeItem != null && this.marketplaces[this.activeItem]) {
        this.marketplaces[this.activeItem].notes = notes
      }
      this.notesForm = notes
      if (this.detailData) {
        this.detailData.notes = notes
      }
      this.setNotesForm(notes)
    },
    buildNotesPayload() {
      return [
        { locale: 'RU', note: this.notesForm.RU || '' },
        { locale: 'EN', note: this.notesForm.EN || '' },
        { locale: 'UZ', note: this.notesForm.UZ || '' },
      ]
    },
    notesLabel(notes) {
      const normalized = this.normalizeNotes(notes)
      return normalized.RU || normalized.EN || normalized.UZ || ''
    },
    openNotesEditor() {
      this.setNotesForm(this.selectedPlace?.notes)
      this.showNotesEditor = true
    },
    closeNotesEditor() {
      this.setNotesForm(this.selectedPlace?.notes)
      this.showNotesEditor = false
    },
    saveNotes() {
      if (!this.locationIdForPrice || this.notesLoading || !this.notesChanged) return
      this.notesLoading = true
      axios.put(`/station-processing-service/api/admin/v1/locations/${this.locationIdForPrice}/notes`, {
        notes: this.buildNotesPayload(),
      })
        .then(() => {
          this.updateSelectedPlaceNotes(this.buildNotesPayload())
          this.showNotesEditor = false
          notify({
            duration: 3000,
            type: 'success',
            title: 'Успешно',
            text: 'Комментарий обновлен.',
          })
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error?.response?.data?.message ?? error.message,
          });
        })
        .finally(() => {
          this.notesLoading = false
        })
    },
    openPriceModal() {
      this.$nextTick(() => {
        const el = document.getElementById('locationPriceModal')
        if (el) {
          const modal = bootstrap.Modal.getOrCreateInstance(el)
          modal.show()
        }
      })
    },
    closePriceModal() {
      const el = document.getElementById('locationPriceModal')
      if (el) {
        const instance = bootstrap.Modal.getInstance(el)
        if (instance) instance.hide()
      }
    },
    onPriceUpdateSuccess(responseData) {
      if (!this.detailData || !responseData) return
      if (responseData.connectors && Array.isArray(responseData.connectors)) {
        this.detailData.connectors = responseData.connectors
      } else if (responseData.connectorPrices && Array.isArray(responseData.connectorPrices)) {
        const byId = {}
        responseData.connectorPrices.forEach((cp) => {
          byId[cp.connectorId] = cp.price
        })
        this.detailData.connectors = (this.detailData.connectors || []).map((c) => {
          const id = c.id ?? c.connectorId
          if (id != null && byId[id] !== undefined) {
            return { ...c, price: byId[id] }
          }
          return c
        })
      }
    },
  },
  watch: {
    selectedListInList: {
      deep: true,
      handler(val) {
        if (val) {
          const key = this.marketplaces.findIndex(mp => mp.id === val)
          this.selectMarketplaceFromList(key)
        } else {
          this.clearSelectedPlaces()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
